<script>
import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  }
};
</script>

<template>
  <div class="c-test-payment-banner py-2">
    <icon
      name="alert-triangle"
      size="small"
    />
    <span class="ms-2">{{ t('pay.js.marketing.test_payment') }}</span>
  </div>
</template>

